<template>
  <div :class="{ 'semi-modal-mode': semiModalMode }" class="ai-assistent">
    <div v-if="semiModalMode" class="semi-modal-header">
      <div>Coach (Análise em tempo real)</div>

      <div @click="$emit('close')" class="close-icon-container">
        <Icon icon="mdi:close" />
      </div>
    </div>

    <div
      :class="{ 'nice-Vscroll p-1 p1': semiModalMode }"
      class="content-container"
    >
      <div :class="{ active: showConfig }" class="config-container">
        <div @click="showConfig = !showConfig" class="icon-settings-container">
          <Icon
            icon="material-symbols:settings-outline"
            class="icon-settings"
          />

          <Icon
            :icon="
              showConfig ? 'octicon:chevron-up-16' : 'octicon:chevron-down-16'
            "
            width="15"
            height="15"
          />
        </div>

        <div v-show="showConfig" class="auto-config-container">
          <div v-if="debugginPermission" class="local-title">
            Exibir Debugging
          </div>

          <b-form-checkbox
            v-if="debugginPermission"
            switch
            autofocus
            v-model="showDebug"
          />

          <div class="local-title">Método de Requisição de Insights</div>

          <v-select
            @input="handleAutoConfigChange"
            :options="autoConfigOptions"
            :reduce="(option) => option.value"
            :clearable="false"
            label="text"
            placeholder="Configuração automática"
            v-model="localUserAutoConfig"
          />
        </div>
      </div>

      <div class="connection-status" :class="statusClass">
        <div class="status-info-container">
          <span class="status-indicator" />

          <span class="status-text">{{ statusText }}</span>
        </div>

        <div class="status-actions-container">
          <div
            v-if="!isConnected && !invalidStreamingToken"
            @click="connectWebSocket()"
            id="connect-cta"
            class="blue-cta"
          >
            <Icon icon="ix:connected" width="20" height="20" />

            <b-tooltip target="connect-cta" placement="bottom">
              Conectar WebSocket
            </b-tooltip>
          </div>

          <div
            v-if="isConnected"
            @click="disconnectWebSocket()"
            id="disconnect-cta"
            class="red-cta"
          >
            <Icon icon="ix:disconnected" width="20" height="20" />

            <b-tooltip target="disconnect-cta" placement="bottom">
              Desconectar WebSocket
            </b-tooltip>
          </div>

          <div
            v-if="invalidStreamingToken"
            @click="renewStreamingToken()"
            id="renew-token-cta"
            class="blue-cta"
          >
            <Icon icon="mdi:refresh" width="20" height="20" />

            <b-tooltip target="renew-token-cta" placement="bottom">
              Renovar Token de Streaming
            </b-tooltip>
          </div>
        </div>
      </div>

      <b-button
        v-if="manualConfig"
        @click="handleInsightsAttempt"
        :disabled="hasPingRequest"
        class="request-insights-button"
        variant="primary"
        block
      >
        <Icon icon="ic:baseline-insights" width="25" height="25" />

        <span>Requisitar Insights</span>
      </b-button>

      <div v-if="hasPingRequest" class="center-container">
        <b-spinner />
      </div>

      <div v-else-if="insights" class="insights-container">
        <div class="new-insights-title">
          <span>Nova análise!</span>
        </div>

        <div class="content-title-container">
          <div class="content-title">Análise do Card</div>

          <div class="insight-timestamp">{{ insightsTimestamp }}</div>
        </div>

        <div class="columns-holder-container">
          <div class="column-container">
            <div
              v-for="(bar, index) in firstColumnBars"
              :key="`first-column-${index}`"
              class="bars-holder"
            >
              <div class="content-title-container">
                <div>{{ bar.title }}</div>

                <div :class="[bar.variant]" class="value-subtitle">
                  {{ bar.value }}/10
                </div>
              </div>

              <b-progress :value="bar.value" :variant="bar.variant" :max="10" />
            </div>
          </div>

          <div class="column-container">
            <div
              v-for="(bar, index) in secondColumnBars"
              :key="`second-column-${index}`"
              class="bars-holder"
            >
              <div class="content-title-container">
                <div>{{ bar.title }}</div>

                <div :class="[bar.variant]" class="value-subtitle">
                  {{ bar.value }}/10
                </div>
              </div>

              <b-progress :value="bar.value" :variant="bar.variant" :max="10" />
            </div>
          </div>
        </div>

        <div class="local-title">Resumo do Card</div>

        <div class="summary-container nice-Vscroll">
          {{ insights.emotional_state.emotional_summary }}
        </div>

        <line-component color="#D9D9D9" />

        <div class="columns-holder-container">
          <div class="column-container">
            <div class="local-title">
              Faça

              <Icon
                icon="teenyicons:up-solid"
                width="15"
                height="15"
                color="#046af3"
              />
            </div>

            <div class="insights-box nice-Vscroll">
              <ul>
                <li
                  v-for="(thing, index) in insights.coaching
                    .alternative_approaches"
                  :key="`first-column-${index}`"
                >
                  {{ thing }}
                </li>
              </ul>
            </div>
          </div>

          <div class="column-container">
            <div class="local-title">
              Evite

              <Icon
                icon="teenyicons:down-solid"
                width="15"
                height="15"
                color="#FF3159"
              />
            </div>

            <div class="insights-box nice-Vscroll">
              <ul>
                <li
                  v-for="(thing, index) in insights.coaching.things_to_avoid"
                  :key="`second-column-${index}`"
                >
                  {{ thing }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="local-title">Sugestões do Coach</div>

        <div class="suggestions-holder">
          <div
            @click="handleSuggestion(suggestion)"
            v-for="(suggestion, index) in suggestions"
            :key="`suggestion-item-${index}`"
            class="suggestion-item"
          >
            <Icon icon="mdi:sparkles" class="suggestion-icon" />

            <div class="suggestion-text">{{ suggestion }}</div>
          </div>
        </div>
      </div>

      <div
        v-if="
          autoConfig ||
          !disabledConfig ||
          (manualConfig && alreadyRequestedPing)
        "
        class="websocket-container"
      >
        <websocket-debug
          v-if="showDebug"
          @send-ping="sendPing()"
          @clear-messages="clearAllMessages()"
          :all-session-messages="allSessionMessages"
          :debugging-messages="debuggingMessages"
          :is-connected="isConnected"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BFormCheckbox,
  BProgress,
  BSpinner,
  BTooltip,
} from "bootstrap-vue";
import { Icon } from "@iconify/vue2";
import moment from "moment";
import vSelect from "vue-select";
import { mapGetters, mapActions, mapMutations } from "vuex";

import { emitter } from "@/plugins/eventBus";
import Line from "@/views/components/Line.vue";
import WebsocketDebug from "@/views/components/Omnichannel/WebsocketDebug.vue";

export default {
  name: "AIAssistent",

  props: {
    dialogId: {
      type: Number,
      required: true,
    },

    requestInsightsOnConnect: {
      type: Boolean,
      default: true,
    },

    semiModalMode: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    BButton,
    BFormCheckbox,
    BProgress,
    BSpinner,
    BTooltip,
    Icon,
    vSelect,

    "line-component": Line,
    "websocket-debug": WebsocketDebug,
  },

  data() {
    return {
      showDebug: false,
      showConfig: false,
      hasPingRequest: false,
      alreadyRequestedPing: false,
      isHandlingInsights: false,

      insights: null,
      lastProcessedTimestamp: null,

      firstColumnBars: [],
      secondColumnBars: [],
      suggestions: [],

      localUserAutoConfig:
        window.localStorage.getItem("aiAssistentAutoConfig") || "manual",

      autoConfigOptions: [
        { value: "auto", text: "Automático" },
        { value: "manual", text: "Manual" },
        { value: "disabled", text: "Desativado" },
      ],

      debbugingRoles: ["admin", "auxiliarTi", "ceo"],
    };
  },

  computed: {
    ...mapGetters("websocket", {
      authFailedImhub: "authFailedImhub",
      invalidStreamingToken: "invalidStreamingToken",
      isConnected: "isConnected",
      wsStatus: "status",
      allSessionMessages: "allSessionMessages",
      debuggingMessages: "debuggingMessages",
      insightMessages: "insightMessages",
      statusClass: "statusClass",
      statusText: "statusText",
      currentInsights: "currentInsights",
    }),

    workspace() {
      return this.$store.getters["app/getUserWorkspace"];
    },

    autoConfig() {
      return this.localUserAutoConfig == "auto";
    },

    manualConfig() {
      return this.localUserAutoConfig == "manual";
    },

    disabledConfig() {
      return this.localUserAutoConfig == "disabled";
    },

    role() {
      return this.$store.getters["app/getUserRole"];
    },

    debugginPermission() {
      return this.debbugingRoles.includes(this.role);
    },

    insightsTimestamp() {
      if (!this.insights) return "";

      return moment(this.insights.timestamp).format("DD/MM/YYYY HH:mm:ss");
    },
  },

  watch: {
    currentInsights() {
      this.handleInsightsResponse();
    },
  },

  created() {
    this.clearInsightMessages();

    this.setContext({ dialogId: this.dialogId });

    if (this.autoConfig) this.handleInsightsAttempt();
  },

  beforeDestroy() {
    this.clearContext();
  },

  methods: {
    ...mapActions("websocket", {
      connect: "connect",
      disconnect: "disconnect",
      sendPing: "sendPing",
    }),

    ...mapMutations("websocket", {
      setContext: "SET_CURRENT_CONTEXT",
      addInsightMessage: "ADD_INSIGHT_MESSAGE",
      clearContext: "CLEAR_CONTEXT",
      clearInsightMessages: "CLEAR_INSIGHT_MESSAGES",
      clearAllMessages: "CLEAR_ALL_MESSAGES",
    }),

    connectWebSocket(fromRequestInsights = false) {
      return this.connect({
        autoReconnect: true,
        retries: 5,
        delay: 3000,
        heartbeat: true,
        heartbeatInterval: 30000,
        heartbeatMessage: "ping",
        fromRequestInsights,
      });
    },

    disconnectWebSocket() {
      this.clearLocalInsights();
      this.disconnect();
    },

    getBarVariantByValue(value) {
      const possibleValues = {
        0: "danger",
        1: "danger",
        2: "danger",
        3: "warning",
        4: "warning",
        5: "warning",
        6: "info",
        7: "info",
        8: "info",
        9: "success",
        10: "success",
      };

      return possibleValues[value] || "danger";
    },

    getBarVariantByReverseValue(value) {
      const possibleValues = {
        10: "danger",
        9: "danger",
        8: "danger",
        7: "warning",
        6: "warning",
        5: "warning",
        4: "info",
        3: "info",
        2: "info",
        1: "success",
        0: "success",
      };

      return possibleValues[value] || "success";
    },

    renewStreamingToken(fromRequestInsights = false) {
      const info = {
        fromRequestInsights,
        username: localStorage.getItem("hubUsername"),
      };

      return this.$store.dispatch("websocket/requestStreamingToken", info);
    },

    clearLocalInsights() {
      this.insights = null;
      this.lastProcessedTimestamp = null;

      this.firstColumnBars = [];
      this.secondColumnBars = [];

      this.hasPingRequest = false;
      this.alreadyRequestedPing = false;
    },

    handleSuggestion(suggestion) {
      if (this.semiModalMode) {
        this.$emit("suggestion-selected", suggestion);

        return;
      }

      emitter.emit("websocket-suggestion-selected", suggestion);
    },

    async handleInsightsAttempt() {
      if (this.isHandlingInsights) return;

      this.isHandlingInsights = true;

      try {
        if (this.invalidStreamingToken) {
          this.$bvToast.toast(
            "Seu token está inválido, recriando token e conectando...",
            {
              title: "Token Inválido!",
              autoHideDelay: 2500,
              variant: "warning",
              toaster: "b-toaster-top-left",
              solid: true,
            }
          );

          await this.renewStreamingToken(true);
          await this.connectWebSocket(true);

          this.sendPingHTTP();

          return;
        }

        if (this.authFailedImhub || this.wsStatus !== "OPEN") {
          this.$bvToast.toast("Conectando ao WebSocket...", {
            title: "Conectando!",
            autoHideDelay: 2500,
            variant: "info",
            toaster: "b-toaster-top-left",
            solid: true,
          });

          try {
            await this.connectWebSocket(true);
            this.sendPingHTTP();
          } catch (error) {
            if (error.message.includes("Invalid")) {
              this.$bvToast.toast(
                "Token inválido detectado, renovando e reconectando...",
                {
                  title: "Renovando Token!",
                  autoHideDelay: 2500,
                  variant: "warning",
                  toaster: "b-toaster-top-left",
                  solid: true,
                }
              );

              await this.renewStreamingToken(true);
              await this.connectWebSocket(true);

              this.sendPingHTTP();
            } else {
              throw error;
            }
          }

          return;
        }

        this.sendPingHTTP();
      } catch (error) {
        this.$bvToast.toast(
          "Não foi possível requisitar insights. Tente novamente.",
          {
            title: "Erro!",
            autoHideDelay: 3000,
            variant: "danger",
            toaster: "b-toaster-top-left",
            solid: true,
          }
        );
      } finally {
        this.isHandlingInsights = false;
      }
    },

    handleAutoConfigChange() {
      window.localStorage.setItem(
        "aiAssistentAutoConfig",
        this.localUserAutoConfig
      );

      if (this.autoConfig && !this.alreadyRequestedPing) this.sendPingHTTP();
    },

    handleInsightsResponse() {
      if (!this.currentInsights) {
        this.clearLocalInsights();

        return;
      }

      const insights = this.currentInsights;

      if (this.lastProcessedTimestamp === insights.timestamp) return;

      this.lastProcessedTimestamp = insights.timestamp;

      const firstColumnBars = [
        {
          title: "Interesse",
          value: insights.emotional_state.readiness_score,
          variant: this.getBarVariantByValue(
            insights.emotional_state.readiness_score
          ),
        },
        {
          title: "Engajamento",
          value: insights.emotional_state.engagement_level,
          variant: this.getBarVariantByValue(
            insights.emotional_state.engagement_level
          ),
        },
        {
          title: "Nível de compromisso",
          value: insights.emotional_state.commitment_readiness,
          variant: this.getBarVariantByValue(
            insights.emotional_state.commitment_readiness
          ),
        },
      ];

      const secondColumnBars = [
        {
          title: "Nível de dúvida",
          value: insights.emotional_state.self_doubt_level,
          variant: this.getBarVariantByReverseValue(
            insights.emotional_state.self_doubt_level
          ),
        },
        {
          title: "Dúvida financeira",
          value: insights.emotional_state.financial_concern_level,
          variant: this.getBarVariantByReverseValue(
            insights.emotional_state.financial_concern_level
          ),
        },
      ];

      const suggestions = insights.coaching.questions_to_ask || [];

      this.firstColumnBars = firstColumnBars;
      this.secondColumnBars = secondColumnBars;
      this.suggestions = suggestions;

      this.insights = insights;
      this.hasPingRequest = false;
    },

    sendPingHTTP() {
      this.hasPingRequest = true;

      const payload = {
        workspace_id: this.workspace.id,
        dialog_id: this.dialogId,
        username: localStorage.getItem("hubUsername"),
        streaming_token: localStorage.getItem("streamingToken"),
      };

      this.$store
        .dispatch("websocket/sendPingHTTP", payload)
        .then(() => {
          this.alreadyRequestedPing = true;
        })
        .catch(() => {
          this.hasPingRequest = false;
        });
    },

    async onWebsocketConnected() {
      if (!this.requestInsightsOnConnect) return;

      if (this.hasPingRequest || this.alreadyRequestedPing) return;

      if (this.autoConfig) await this.handleInsightsAttempt();
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-assistent {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 20px 20px 20px;
  gap: 15px;
  border-radius: 6px;
  border: 1px solid #d9d9d9;

  &.semi-modal-mode {
    flex-grow: 1;
    padding: 0;
    gap: 0;
    border-radius: 0;
    border: none;
  }

  .semi-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    font-weight: 600;
    width: 100%;
    padding: 15px;
    border-bottom: 1px solid #d9d9d9;
    color: #31333f;

    .close-icon-container {
      font-size: 25px;
      color: #31333f;
      cursor: pointer;

      &:hover {
        color: #dc3545;
      }
    }
  }

  .content-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    gap: 15px;
  }

  .config-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 10px;
    gap: 10px;
    user-select: none;

    .icon-settings-container {
      display: flex;
      align-items: center;
      font-size: 25px;
      margin: -7px -20px -10px auto;
      color: #31333f;
      cursor: pointer;

      .icon-settings {
        width: 25px;
        height: 25px;

        &:hover {
          color: #046af3;
        }
      }
    }

    &.active {
      border-bottom: 1px solid #d9d9d9;
    }

    .auto-config-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 10px;
    }
  }

  .connection-status {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
    gap: 15px;
    padding: 12px 16px;
    border-radius: 6px;
    transition: all 0.3s ease;

    .status-info-container {
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 80%;
      overflow: hidden;
    }

    &.connected {
      border: 1px solid #c3e6cb;
      background: #d4edda;
      color: #155724;
    }

    &.connecting {
      border: 1px solid #ffeaa7;
      background: #fff3cd;
      color: #856404;
    }

    &.disconnected {
      border: 1px solid #f5c6cb;
      background: #f8d7da;
      color: #721c24;
    }

    .status-indicator {
      height: 10px;
      width: 10px;
      border-radius: 50%;
    }

    &.connected .status-indicator {
      background: #28a745;
    }

    &.connecting .status-indicator {
      background: #ffc107;
    }

    &.disconnected .status-indicator {
      background: #dc3545;
    }

    .status-actions-container {
      display: flex;
      align-items: center;
      gap: 15px;

      .blue-cta,
      .red-cta {
        transition: all 0.2s ease;
        color: #31333f;
        cursor: pointer;

        &:hover {
          transform: translateY(-2px);
        }
      }

      .blue-cta {
        &:hover {
          color: #046af3;
        }
      }

      .red-cta {
        &:hover {
          color: #dc3545;
        }
      }
    }
  }

  .request-insights-button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 10px;
    gap: 5px;
  }

  .center-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 10px;
  }

  .insights-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 15px 0;
    gap: 15px;

    .new-insights-title {
      position: relative;
      border-radius: 6px;
      border-bottom: 2px solid #046af3;

      span {
        position: absolute;
        font-size: 16px;
        font-weight: 600;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 5px 10px;
        background: #ffffff;
        color: #046af3;
      }
    }

    .content-title-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .content-title {
        font-size: 16px;
        font-weight: 600;
        color: #313131;
      }

      .insight-timestamp {
        font-size: 12px;
        font-weight: 500;
        color: #6c757d;
      }

      .value-subtitle {
        &.danger {
          color: #dc3545;
        }

        &.warning {
          color: #ffc107;
        }

        &.info {
          color: #046af3;
        }

        &.success {
          color: #28a745;
        }
      }
    }

    .columns-holder-container {
      display: flex;
      justify-content: space-between;
      width: 100%;
      gap: 15px;

      .column-container {
        display: flex;
        align-content: stretch;
        flex-direction: column;
        width: 48%;
        gap: 15px;

        .bars-holder {
          display: flex;
          flex-direction: column;
          width: 100%;
          gap: 5px;
        }
      }

      .insights-box {
        max-height: 100px;
        width: 100%;
        border-radius: 6px;
        border: 1px solid #d9d9d9;
        padding: 10px 10px 10px 0px;
        overflow-x: hidden;
      }
    }

    .summary-container {
      text-align: justify;
      max-height: 100px;
      width: 100%;
      padding: 10px;
      border-radius: 6px;
      border: 1px solid #d9d9d9;
    }

    .suggestions-holder {
      display: flex;
      flex-direction: column;
      gap: 10px;

      .suggestion-item {
        display: flex;
        padding: 10px 15px;
        gap: 10px;
        border-radius: 40px;
        border: 1px solid #d9d9d9;
        cursor: pointer;

        .suggestion-icon {
          font-size: 25px;
          min-height: 25px;
          min-width: 25px;
          color: #046af3;
        }

        .suggestion-text {
          margin: auto 0;
        }

        &:hover {
          background: #e2e6ea;
        }
      }
    }
  }

  .websocket-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 15px;
  }
}

.local-title {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  gap: 5px;
  margin-bottom: -5px;
  color: #31333f;
}
</style>
